var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M512,256c0,141.384-114.616,256-255.999,256C114.616,512,0,397.384,0,256 C0,256.061,256.001,0.028,256.001,0C397.384,0,512,114.616,512,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "122.435,256 208.777,256 133.565,166.957 122.435,200.348  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "256.001,208.778 166.957,122.435 256,122.435  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256.001,0c-0.016,0-0.029,0-0.043,0H256.001L256.001,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M255.315,256H256c0-0.23,0-0.454,0-0.685C255.772,255.544,255.544,255.772,255.315,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256.001,133.565c0-45.045,0-74.561,0-133.565h-0.043C114.592,0.024,0,114.629,0,256h133.566 v-75.211L208.777,256h46.54c0.228-0.228,0.456-0.456,0.685-0.685c0-17.247,0-32.636,0-46.537l-75.214-75.213H256.001z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M129.515,33.391C89.476,56.19,56.19,89.476,33.391,129.515V256h66.783V100.176v-0.002H256 c0-21.063,0-41.129,0-66.783H129.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256.001,224.519l-90.955-90.953h-31.48v0.002L255.999,256h0.002 C256.001,256,256.001,234.293,256.001,224.519z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "279.406,422.957 284.932,439.963 302.813,439.963 288.348,450.473 293.874,467.478  279.406,456.969 264.941,467.478 270.467,450.473 256,439.963 273.88,439.963  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "421.811,311.652 427.336,328.658 445.217,328.658 430.752,339.169 436.279,356.174  421.811,345.665 407.346,356.174 412.872,339.169 398.404,328.658 416.285,328.658  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "457.493,144.696 463.019,161.702 480.9,161.702 466.435,172.212 471.96,189.217  457.493,178.708 443.028,189.217 448.554,172.212 434.087,161.702 451.968,161.702  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "466.333,267.13 471.858,284.137 489.739,284.137 475.274,294.647 480.8,311.652  466.333,301.143 451.868,311.652 457.394,294.647 442.926,284.137 460.807,284.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "305.046,382.959 320.981,391.078 333.624,378.435 330.828,396.094 346.759,404.212  329.097,407.01 326.3,424.671 318.184,408.738 300.522,411.537 313.165,398.894  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "305.046,316.177 320.981,324.295 333.624,311.652 330.828,329.312 346.759,337.429  329.097,340.227 326.3,357.888 318.184,341.956 300.522,344.754 313.165,332.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "360.698,358.984 376.633,367.103 389.276,354.46 386.48,372.119 402.411,380.237  384.749,383.035 381.952,400.696 373.836,384.762 356.174,387.562 368.817,374.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "360.698,216.003 376.633,224.121 389.276,211.478 386.48,229.138 402.411,237.255  384.749,240.053 381.952,257.714 373.836,241.782 356.174,244.58 368.817,231.937  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "414.635,214.289 430.57,222.407 443.213,209.764 440.416,227.424 456.348,235.541  438.686,238.339 435.889,256 427.773,240.068 410.111,242.866 422.754,230.223  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.7da7a8ba5237ffd984aa4d6f79fe7cca.svg";
export { ForwardRef as ReactComponent };